type Environment = "development" | "production" | "test";

interface Config {
  apiBaseUrl: string;
}

const env = (process.env.NODE_ENV as Environment) || "development";

const configs: Record<Environment, Config> = {
  development: {
    apiBaseUrl: "http://localhost:8866/api",
  },
  production: {
    apiBaseUrl: "https://api-mail.amoustms.app/api",
  },
  test: {
    apiBaseUrl: "http://localhost:8866/api",
  },
};

export const config = configs[env];
